export default __webpack_public_path__ + "static/media/link-page-tutorial.719e1bae.png";